import React from 'react';
import classNames from 'classnames';

import styles from '../styles/videoContentBoxItem.module.scss';

const VideoContentBoxItem = ({
  className,
  hasBorder,
  children,
}) => (
  <div className={classNames(className, styles.item, { [styles.hasBorder]: hasBorder })}>
    {children}
  </div>
);

export default React.memo(VideoContentBoxItem);
